// Log build-time environment info
console.log('[CONFIG] Build Environment:', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_MIGRATION_FORM_PATH: process.env.REACT_APP_MIGRATION_FORM_PATH,
});

// Validate required environment variables
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
if (!API_BASE_URL) {
  throw new Error(
    'REACT_APP_API_BASE_URL is not configured. Please set it in .env.local (dev) or .env.production (prod)'
  );
}

// Determine frontend URL based on API URL
const FRONTEND_BASE_URL = API_BASE_URL.includes('staging')
  ? 'https://dash-staging.dashzap.com'
  : API_BASE_URL.includes('localhost')
  ? 'http://localhost:3000'
  : 'https://dash.dashzap.com';

// Construct migration form endpoint from base URL and path
const MIGRATION_FORM_PATH = process.env.REACT_APP_MIGRATION_FORM_PATH || '';
const MIGRATION_FORM_ENDPOINT = MIGRATION_FORM_PATH
  ? `${API_BASE_URL}/mail-handler/send/${MIGRATION_FORM_PATH}`
  : '';

export const config = {
  API_BASE_URL,
  FRONTEND_BASE_URL,

  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',

  // Migration form endpoint (empty if not configured)
  MIGRATION_FORM_ENDPOINT,

  // Newsletter endpoints
  endpoints: {
    newsletters: '/newsletter',
    newsletter: (id: string) => `/newsletter/${id}`,
    createNewsletter: '/newsletter',
    updateNewsletter: (id: string) => `/newsletter/${id}`,
    deleteNewsletter: (id: string) => `/newsletter/${id}`,
    sendNewsletter: (id: string) => `/newsletter/${id}/send`,
    tracking: (id: string) => `/newsletter/${id}/tracking`,

    // Auth endpoints
    auth: {
      initiate: (company: string) => `/auth/initiate/${company}`,
      callback: '/auth/callback',
      validate: (company: string) => `/auth/validate/${company}`,
      refresh: '/auth/refresh',
      logout: '/auth/logout',
    },

    // Admin endpoints
    admin: {
      addCompany: '/admin/add-company',
      dashboard: (company: string) => `/admin/${company}`,
      addUser: (company: string) => `/admin/add-user/${company}`,
      removeUser: (company: string) => `/admin/remove-user/${company}`,
      deleteCompany: (company: string) => `/admin/delete-company/${company}`,
      reactivateCompany: (company: string) => `/admin/reactivate-company/${company}`,
    }
  }
};